module.exports = __webpack_public_path__ + "img/horizontal_3_7_r_pp1_6000.aef30df3.png";